export default __webpack_public_path__ + "static/media/Steele.616522aa.png";